<template>
  <article
    v-if="garageSupportedServices"
    class="garage-supported-services"
  >
    <h2 class="garage-supported-services__header">Usługi wykonywane przez warsztat</h2>

    <ul class="garage-supported-services__lists">
      <li
        v-for="parentService in mappedSupportedServices"
        class="garage-supported-services__list"
      >
        <a
          class="garage-supported-services__services-parent-name"
          :href="`https://dobrymechanik.pl/uslugi/${parentService.slug}/${city}/`"
        >
          <span>{{ parentService.name }}</span>
        </a>
        <ul class="garage-supported-services__services">
          <li
            v-for="service in parentService.services"
            :key="service.id"
            class="garage-supported-services__service"
          >
            <a :href="`https://dobrymechanik.pl/uslugi/${service.slug}/${city}/`">
              <span>{{ service.name }}</span>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </article>
</template>

<script
  setup
  lang="ts"
>
import type { GarageSupportedServiceJsonldSupportedServiceReadServiceRead } from '~/api/docs/api';

interface IProps {
  garageSupportedServices: GarageSupportedServiceJsonldSupportedServiceReadServiceRead[];
}

const props = defineProps<IProps>();

// use
const route = useRoute();

// computed
const city = computed(() => {
  return route.params['city'] as string;
});

const mappedSupportedServices = computed(() => {
  const parentsArr = props.garageSupportedServices
    .map((el) => {
      return {
        id: !!el.service?.parent ? el.service.parent.id : el.service?.id,
        name: !!el.service?.parent ? el.service.parent.name : el.service?.name,
        slug: !!el.service?.parent ? el.service.parent.slug : el.service?.slug,
      };
    })
    .filter((value, index, arr) => {
      const flatArr = arr.map(el => el.id);
      return flatArr.indexOf(value.id) === index;
    });

  return parentsArr
    .map(parent => {
      const serviceData = props.garageSupportedServices.filter(el => {
        return !!el.service?.parent && el.service.parent.id === parent.id;
      });

      return {
        ...parent,
        services: serviceData.map((data => {
          return {
            name: data.service?.name,
            slug: data.service?.slug,
            id: data.service?.id
          };
        })
        )
      };
    });
});
</script>

<style
  lang="scss"
  scoped
>
@import url('assets/styles/components/garage-supported-services.scss');
</style>